import Vue from 'vue'
import App from './vue_files/App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import vuetify from './plugins/vuetify'
import './plugins/vee-validate'
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import AlertCmp from './vue_files/components/Shared/Alert.vue'
import VueCookieLaw from 'vue-cookie-law'

Vue.config.productionTip = false

// Register VueCookieLaw globally
Vue.component('vue-cookie-law', VueCookieLaw)
Vue.component('app-alert', AlertCmp)

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCDSGmQN9hImWTB1iUvBnmzFDelFs1mqjE',
  authDomain: 'make-electronic-sound.firebaseapp.com',
  projectId: 'make-electronic-sound',
  storageBucket: 'make-electronic-sound.appspot.com',
  messagingSenderId: '96674523622',
  appId: '1:96674523622:web:efe5a9a410275e4364ce27',
  measurementId: 'G-9BWQM7LD32'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig) // Always initialize Firebase
const auth = getAuth(app) // Set up Firebase Authentication

Vue.prototype.$firebaseAuth = auth // Set up Firebase Authentication in Vue prototype

new Vue({
  router,
  store,
  vuetify,
  provide: {
    eventBus: new Vue(),
  },
  created () {
    // Handle automatic sign-in with Firebase Authentication
    if (this.$firebaseAuth) {
      this.$firebaseAuth.onAuthStateChanged((user) => {
        if (user) {
          this.$store.dispatch('autoSignIn', user)
        }
      })
    }
  },
  render: h => h(App),
}).$mount('#app')

// Export Firebase Auth
export { auth }
